"use client";
import * as React from "react";
import { type VariantProps } from "class-variance-authority";

import gsap from "gsap";
import { useEffect, useRef } from "react";

interface ScrollIndicatorProps
  extends React.Component<any>,
    VariantProps<any> {}

const ScrollIndicator = React.forwardRef<any, ScrollIndicatorProps>(
  ({ ...props }, ref) => {
    const Comp: any = "scrollIndicator";
    const Child: any = "scrollIndicatorBar";

    const progressBar = useRef(null);

    useEffect(() => {
      const updateProgressBar = () => {
        const scrollY = window.scrollY;
        const docHeight =
          document.documentElement.scrollHeight - window.innerHeight;
        const progress = (scrollY / docHeight) * 100;
        gsap.to(progressBar.current, {
          height: `${progress}%`,
          ease: "power3.out",
        });
      };

      window.addEventListener("scroll", updateProgressBar);

      return () => {
        window.removeEventListener("scroll", updateProgressBar);
      };
    }, []);

    return (
      <Comp
        className="fixed top-[calc(1vh*40)] right-4 bg-gray-200 dark:bg-gray-900 h-40 w-1.5 inline-flex items-center justify-center whitespace-nowrap rounded-sm"
        ref={ref}
        {...props}
      >
        <Child
          ref={progressBar}
          className="w-1.5 h-10 bg-gray-900 dark:bg-gray-200 rounded-sm absolute top-0"
        />
      </Comp>
    );
  }
);
ScrollIndicator.displayName = "ScrollIndicator";

export { ScrollIndicator };
